import { IPluginSettingPage, PluginCore } from "./core/PluginCore";
import { IFeedbackSetting, IServerSettings } from "./Interfaces";
import { Plugin } from "./NPS_Main";

// eslint-disable-next-line no-unused-vars
    /* server Setting page closure*/
    export function ServerSettingsPage(): IPluginSettingPage<IServerSettings> {
        
        let self: IPluginSettingPage<IServerSettings> = {};
        if (window["ConfigPage"] !== undefined) {
            self = { ...Object.getPrototypeOf(new ConfigPage()) };
        }
        self.settings = () => {

            
            return { ...Plugin.config.customerSettingsPage.defaultSettings, ...PluginCore.getServerSetting(Plugin.config.customerSettingsPage.settingName, { timeOutBeforePopup:20000, daysAfterClosedPopup:7  ,daysBeetweenFeedbacks:180}) }
        };

        /** Customize this method to generate static HTML.  */
        self.getSettingsDOM = (settings: IServerSettings): JQuery => {
            return $(`
                <div class="panel-body-v-scroll fillHeight">
                    <div>
                    <div id="controls">
                    <table class="table table-striped table-bordered table-hover" style="width:70vw">
                    <thead>
                        <tr>
                            <th style="width:20%">Who</th>
                            <th style="width:20%" >When</th>
                            <th style="width:5%">CSAT</th>
                            <th style="width:5%">NPS</th>
                            <th>Comment</th>
                        </tr>
                        </thead>
                        <tbody>
                        </tbody>
                    </div>
                    </div>
                </div>
            `);
        };
        /** Customize this method to add dynamic content*/
        self.showSimple = () => {

            let feebackSetting:IFeedbackSetting = { feedbacks:[]};
            restConnection.getServer("user").then((users: XRGetUserListAck) => { 
                for(let user of users.user)
                {
                    console.log(user.login);
                    user.userSettingsList.forEach((userSetting) => { 
                        if( userSetting.key == Plugin.config.customerSettingsPage.settingName)
                        {

                            let settingValue = JSON.parse(userSetting.value);
                            console.log(settingValue);
                            for (let feedback of settingValue.feedbacks)
                            feebackSetting.feedbacks.push(feedback);
                        }
                    });
                }
                self.settingsChanged = { ...self.settingsOriginal };
                let dom = self.getSettingsDOM(self.settingsChanged);
                app.itemForm.append(dom);
                for (let feedback of feebackSetting.feedbacks) { 
                    let tr = $(`<tr><td>${feedback.user}</td><td>${feedback.submitDate}</td><td>${feedback.csat}</td><td>${feedback.nps}</td><td>${feedback.feedback}</td></tr>`);
                    $("tbody", dom).append(tr);
                }
            });



          

        };



        self.renderSettingPage = () => {
         
            self.initPage(
                `${Plugin.PLUGIN_NAME} - Server settings`,
                true,
                undefined,
                Plugin.config.customerSettingsPage.help,
                Plugin.config.customerSettingsPage.helpUrl,
                undefined
            );
            self.showSimple();
        };

        self.showAdvanced = () => {
            console.debug("Show advanced clicked");
            self.showAdvancedCode(JSON.stringify(self.settings()), function (newCode: string) {
                self.settingsChanged = JSON.parse(newCode);
                self.paramChanged();
            });
        };
       
        
        self.saveAsync = () => {
            let def = configApp.setServerSettingAsync(Plugin.config.customerSettingsPage.settingName, JSON.stringify(self.settingsChanged));
            def.done(() => {
                self.settingsOriginal = { ...self.settingsChanged };
                self.renderSettingPage();
            })
            return def
        }

        self.paramChanged = () => {
            configApp.itemChanged(JSON.stringify(self.settingsOriginal) != JSON.stringify(self.settingsChanged));
        }
      
     
        return self;
    }
